import React from 'react';
import { Tool } from '../basic';
import { intl } from '../../lib';
import type { VoidCallback } from '../common-types';

/**
 * Props for the BackButton component.
 */
interface BackButtonProps {
  onClick?: VoidCallback;
  title?: string | React.JSX.Element;
  titleClass?: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4';
}

/**
 * A back button with an optional title.
 * @param onClick Callback when the button is clicked.
 * @param title Optional title to display next to the button.
 * @param titleClass Optional CSS class for the title.
 * @param titleTag Optional HTML tag for the title (default is 'h2').
 * @constructor
 */
export function BackButton({
  onClick,
  title,
  titleClass = 'title',
  titleTag = 'h2'
}: Readonly<BackButtonProps>): React.JSX.Element {
  return (
    <div className="ehs-back-button">
      <Tool
        icon="materialicon-chevron_left"
        onClick={() => onClick?.()}
        tooltip={intl('view.button.back')}
        variant="transparent"
        className="back-icon"
      />
      {title &&
        React.createElement(
          titleTag,
          { className: `${titleClass} sh-font` },
          title
        )}
    </div>
  );
}
